module.exports = __webpack_public_path__ + "public/Icons/rightArrowBtn.png?d7a5a82f";